import ConfigStore from './config-store.js';

export default new ConfigStore(window);
